export default function getToken(param){
    const userInfo = JSON.parse(localStorage.getItem('lesson_session'))
    if(param){
       return userInfo[param]
    }
    return userInfo
}